import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter,HashRouter } from "react-router-dom";
import './index.css';
import './index.scss';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
/*   <React.StrictMode> */
    <BrowserRouter> 
      <App />
    </BrowserRouter>

/*   </React.StrictMode> */
);

